import React, { Fragment } from 'react';
import { NativeAd } from 'site-modules/shared/components/ad-unit/native-ad';
import { MrectNative } from 'site-modules/shared/components/native-ad/mrect/mrect-native';
import { FilmstripTypeRankingFeatured } from 'site-modules/shared/components/native-ad/filmstrip-type-ranking/filmstrip-type-ranking-featured';
import { NativeVideoAd } from 'site-modules/shared/components/native-ad/video/video-native-ad';
import { SponsoredCars } from 'site-modules/shared/components/core-page/sponsored-cars/sponsored-cars';
import { MinHeightWrapper } from 'site-modules/shared/components/min-height-wrapper/min-height-wrapper';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

export const getSubtypeAds = (trkParam, isMobile, isInline, paddingBottomSegmentListing = '1rem') => {
  const inlineStyle = isInline
    ? {
        marginBottom: '4.5rem',
        marginTop: '4.5rem',
      }
    : {
        paddingBottom: '1rem',
      };
  const inlineBillboardLeaderboardStyle = {
    marginBottom: '1rem',
    marginTop: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
  const renderSegmentListingAd = ads12491Recipe => (
    <FilmstripTypeRankingFeatured
      key={'segment-listing-ad'}
      mobile={isMobile}
      inlineStyle={{ ...inlineStyle, paddingBottom: paddingBottomSegmentListing }}
      cardClass="ranking-vehicle-card is-large-card"
      ads12491Recipe={ads12491Recipe}
    />
  );
  const renderBillboardLeaderboardAd = position => (
    <div style={{ minHeight: '250px', ...inlineBillboardLeaderboardStyle }}>
      <NativeAd
        adNameWired="billboard,leaderc"
        nativeStyle="leaderboard"
        wiredOnly
        position={position}
        customTargeting={trkParam}
        dfpCollapse
        noRefresh
        customSizes={[
          [1, 1],
          [728, 90],
          [970, 250],
        ]}
      />
    </div>
  );
  return {
    pos1: (
      <Fragment key={'pos-1-leaderboard-mrect'}>
        {isMobile ? (
          <MrectNative
            position={'1'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        ) : (
          renderBillboardLeaderboardAd('0')
        )}
      </Fragment>
    ),
    pos2: (
      <Fragment key={'pos-2-leaderboard-mrect'}>
        {!isMobile && renderBillboardLeaderboardAd('2')}
        {isMobile && (
          <MrectNative
            position={'2'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        )}
      </Fragment>
    ),
    segmentListing: renderSegmentListingAd(null),
    segmentListingAds12491Chal1: renderSegmentListingAd('chal1'),
    segmentListingAds12491Chal2: renderSegmentListingAd('chal2'),
    videoAd: (
      <Experiment name="ads-11436" showDefault key={'video-ad'}>
        <Recipe name="ctrl" isDefault>
          <div className="mx-auto" style={{ width: '360px', height: '363px', ...inlineStyle }}>
            <NativeVideoAd useMinHeight renderWhenViewable verticalOffset="100%" />
          </div>
        </Recipe>
        <Recipe name="chal" />
      </Experiment>
    ),
    filmstrip: (
      <MinHeightWrapper componentType="SPONSORED_CARS_STACKED" style={isMobile ? null : { maxWidth: '744px' }}>
        <SponsoredCars
          showLargeArrows
          verticalOffset="50%"
          showBottomDividingLine={false}
          inlineStyle={inlineStyle}
          showStackedAds
        />
      </MinHeightWrapper>
    ),
    pos3: (
      <Fragment key={'pos-3-leaderboard-mrect'}>
        {!isMobile && renderBillboardLeaderboardAd('3')}
        {isMobile && (
          <MrectNative
            position={'3'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        )}
      </Fragment>
    ),
    pos4: (
      <Fragment key={'pos-4-leaderboard-mrect'}>
        {!isMobile && renderBillboardLeaderboardAd('4')}
        {isMobile && (
          <MrectNative
            position={'4'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        )}
      </Fragment>
    ),
  };
};
